import type { ReactNode } from 'react'
import { useAuth } from 'react-oidc-context'
import { ServiceContext } from './ServiceContext'
import { httpLayoutService } from './http/layoutService'
import { httpPageService } from './http/pageService'
import { httpArticleService } from './http/articleService'
import { httpArtifactService } from './http/imageService'
import { httpAdminService } from './http/adminService'
import { setApiToken } from './http/wireApiClient'

const services = {
  layoutService: httpLayoutService,
  pageService: httpPageService,
  articleService: httpArticleService,
  artifactService: httpArtifactService,
  adminService: httpAdminService,
}

export function ServiceProvider({ children }: { children: ReactNode }) {
  const auth = useAuth()
  setApiToken(auth.user?.id_token)

  return (
    <ServiceContext.Provider value={services}>
      {children}
    </ServiceContext.Provider>
  )
}
